module.exports = __webpack_public_path__ + "img/file2.f5d5af10.svg";